import React from 'react'
import PropTypes from 'prop-types'
import { compose } from 'recompose'
import { withStyles } from '@material-ui/core/styles'
import AppBar from '@material-ui/core/AppBar'
import Toolbar from '@material-ui/core/Toolbar'
import Grid from '@material-ui/core/Grid'
import Typography from '@material-ui/core/Typography'
import HomeContent from 'pages/HomeContent'
import PrivateRoute from 'utils/PrivateRoute'
import { withTranslation } from 'react-i18next'
import Button from '@material-ui/core/Button'


const styles = (theme) => ({
	secondaryBar: {
		zIndex: 0,
	},
})

function Dashboard({ t, classes, location, pageContext }) {
	const title = t(`${pageContext.titleKey}.title`)
	return (
		<>
			<AppBar component="div" className={classes.secondaryBar} color="primary" position="static" elevation={0}>
				<Toolbar>
					<Grid container alignItems="center" spacing={2}>
						<Grid item xs>
							<Typography style={{ textTransform: 'capitalize' }} color="inherit" variant="h5">
								{title}
							</Typography>
						</Grid>
						<Grid item>
							<Button
								className={classes.button}
								variant="outlined"
								color="inherit"
								size="small"
								onClick={() => {
									window.open("https://dieta-public-resources.s3.us-west-2.amazonaws.com/Videos/CS1710-Labeling-Instructions.mp4");
								}}
							>
								Instructions
							</Button>
						</Grid>
					</Grid>
				</Toolbar>
			</AppBar>
			<HomeContent />
		</>
	)
}

Dashboard.propTypes = {
	location: PropTypes.object,
}

const DashboardPage = ({ location, ...rest }) => {
	return <PrivateRoute location={location} component={Dashboard} {...rest} />
}

export default compose(withStyles(styles), withTranslation())(DashboardPage)
